import React from 'react';
import {Property} from 'csstype';
import {line as d3line} from 'd3-shape';
import {scales} from 'components/dashboard/manager/nine-box/NineBox.const';

interface DashedLineProps extends React.SVGProps<SVGGElement> {
  at: [[number, number], [number, number]];
  color: Property.Color;
  value?: string;
}

/**
 * Draw a line
 */
export const DashedLine: React.FC<DashedLineProps> = ({at, color, onMouseEnter, onMouseLeave}) => {
  const {xScale, yScale} = scales;

  const line = d3line()
    .x(d => xScale(d[0])!)
    .y(d => yScale(d[1])!);

  return (
    <g onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <path
        d={line(at)!}
        style={{
          stroke: color,
          strokeWidth: 1.5,
          strokeDasharray: 4,
          strokeLinecap: 'round',
          fill: 'none',
        }}
      />
      {onMouseEnter && (
        <path
          d={line(at)!}
          style={{
            stroke: 'transparent',
            strokeWidth: 10,
            fill: 'none',
          }}
        />
      )}
    </g>
  );
};
